module.exports = __webpack_public_path__ + "static/media/our-experts-bg.5426b44c.png";